import React from "react";
import { Link } from "react-router-dom";

const HoldPage = ({ holdMessage }) => {
  return (
    <section className="fw-screen fw-screen--plain fw-fade fw-hold">
      <div className="fw-brand fw-brand--small">
        <span className="fw-brand__top">
          FUNDS
        </span>

        <span className="fw-brand__bottom">
          WALLE
        </span>
      </div>

      <h1>You’re almost there</h1>

      <p>{holdMessage}</p>

      <Link
        to="/"
        className="fw-btn fw-btn--ghost"
      >
        Back to Home
      </Link>
    </section>
  );
};

export default HoldPage;